export default {
    ADD_CONSTRUCTION(state, constructionData) {
        if (state.constructionsData.length === 0) {
            state.constructionsData.push(constructionData);
        } else {
            let index = state.constructionsData.findIndex(
                element => element.id == constructionData.id
            );
            if (index === -1) {
                state.constructionsData.push(constructionData);
            } else {
                state.constructionsData[index] = constructionData;
            }
        }
    },
    ADD_TECH_INSTALLATION(state, techInstallation) {
        if (state.techInstallations.length === 0) {
            state.techInstallations.push(techInstallation);
        } else {
            let index = state.techInstallations.findIndex(
                element => element.id == techInstallation.id
            );
            if (index === -1) {
                state.techInstallations.push(techInstallation);
            } else {
                state.techInstallations[index] = techInstallation;
            }
        }
    },
    ADD_TOOLS(state, tools) {
        if (state.tools.length === 0) {
            state.tools.push(tools);
        } else {
            let index = state.tools.findIndex(
                element => element.id == tools.id
            );
            if (index === -1) {
                state.tools.push(tools);
            } else {
                state.tools[index] = tools;
            }
        }
    },
    ADD_TRANSPORTATION(state, transportation) {
        if (state.transportation.length === 0) {
            state.transportation.push(transportation);
        } else {
            let index = state.transportation.findIndex(
                element => element.id == transportation.id
            );
            if (index === -1) {
                state.transportation.push(transportation);
            } else {
                state.transportation[index] = transportation;
            }
        }
    },
    ADD_LABOUR(state, labourCard) {
        state.labourCard = labourCard;
    },
    REMOVE_CONSTRUCTION(state, id) {
        let index = state.constructionsData.findIndex(
            construction => construction.id == id
        );
        if (index !== -1) state.constructionsData.splice(index, 1);
    },
    REMOVE_TECH_INSTALLATION(state, id) {
        let index = state.techInstallations.findIndex(
            techInstallation => techInstallation.id == id
        );
        if (index !== -1) state.techInstallations.splice(index, 1);
    },

    REMOVE_TOOLS(state, id) {
        let index = state.tools.findIndex(tools => tools.id == id);
        if (index !== -1) state.tools.splice(index, 1);
    },
    REMOVE_TRANSPORTATION(state, id) {
        let index = state.transportation.findIndex(
            transportation => transportation.id == id
        );
        if (index !== -1) state.transportation.splice(index, 1);
    },
    ADD_FURNITURE_CARD(state, furnitureCard) {
        if (state.furnitureCard.length === 0) {
            state.furnitureCard.push(furnitureCard);
        } else {
            let index = state.furnitureCard.findIndex(
                element => element.id == furnitureCard.id
            );
            if (index === -1) {
                state.furnitureCard.push(furnitureCard);
            } else {
                state.furnitureCard[index] = furnitureCard;
            }
        }
    },
    REMOVE_FURNITURE_CARD(state, id) {
        let index = state.furnitureCard.findIndex(
            furnitureCard => furnitureCard.id == id
        );
        if (index !== -1) state.furnitureCard.splice(index, 1);
    },
    ADD_TECH_HARDWARE(state, techHardware) {
        if (state.techHardware.length === 0) {
            state.techHardware.push(techHardware);
        } else {
            let index = state.techHardware.findIndex(
                element => element.id == techHardware.id
            );
            if (index === -1) {
                state.techHardware.push(techHardware);
            } else {
                state.techHardware[index] = techHardware;
            }
        }
    },
    ADD_ITMO(state, itmo) {
        if (state.itmo.length === 0) {
            state.itmo.push(itmo);
        } else {
            let index = state.itmo.findIndex(element => element.id == itmo.id);
            if (index === -1) {
                state.itmo.push(itmo);
            } else {
                state.itmo[index] = itmo;
            }
        }
    },
    REMOVE_TECH_HARDWARE(state, id) {
        let index = state.techHardware.findIndex(
            techHardware => techHardware.id == id
        );
        if (index !== -1) state.techHardware.splice(index, 1);
    },
    REMOVE_ITMO(state, id) {
        let index = state.itmo.findIndex(itmo => itmo.id == id);
        if (index !== -1) state.itmo.splice(index, 1);
    },

    PUT_CONSTRUCTION_DATA(state, constructionsData) {
        state.constructionsData = constructionsData;
    },

    PUT_TECH_INSTALLATIONS(state, techInstallations) {
        state.techInstallations = techInstallations;
    },

    PUT_LABOUR_CARD(state, labourCard) {
        state.labourCard = labourCard;
    },

    PUT_TOOLS(state, tools) {
        state.tools = tools;
    },

    PUT_TRANSPORTATION(state, transportation) {
        state.transportation = transportation;
    },

    PUT_FURNITURE_CARD(state, furnitureCard) {
        state.furnitureCard = furnitureCard;
    },

    PUT_TECH_HARDWARE(state, techHardware) {
        state.techHardware = techHardware;
    },
    PUT_ITMO(state, itmo) {
        state.itmo = itmo;
    }
};
